module.exports = __webpack_public_path__ + "static/img/other.07e6514.png";


//////////////////
// WEBPACK FOOTER
// ./static/other.png
// module id = aKz5
// module chunks = 1